// removed by extract-text-webpack-plugin
module.exports = {"List":"_2jhRW","ListItem":"_226TM","Image":"_11k1S","ListItemActive":"_17Sbx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Baggage/BaggageSelect/BaggageSelect.scss
// module id = 598
// module chunks = 0